//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
    BUY_PROPERTY,
    TRANSFER_YEAR,
    ONLY_HOUSE,
    calcOldHouse,
    checkSubmit,
    formatNumberInput
    } from './utils'
export default {
    data () {
        return {
            type: '二手房',
            all_price: '',
            building_area: '',
            buy_propertys: BUY_PROPERTY,
            transfer_year: TRANSFER_YEAR,
            only_house: ONLY_HOUSE,
            buy_property_index: 0,
            transfer_year_index: 0,
            only_house_index: 0,
        }
    },
    methods: {
        changeBuyProperty ({ target: { value } }) {
            this.buy_property_index = value
        },
        changeTransferYear ({ target: { value } }) {
            this.transfer_year_index = value
        },
        changeOnlyHouse ({ target: { value } }) {
            this.only_house_index = value
        },
        checkBuildingArea (e) {
            this.building_area = formatNumberInput(e)
        },
        checkAllPrice (e) {
            this.all_price = formatNumberInput(e)
        },
        calculate () {
            const params = {
                type: this.type,
                all_price: this.all_price,
                area: this.building_area,
                transfer_year: this.transfer_year[this.transfer_year_index],
                buy_property: this.buy_propertys[this.buy_property_index],
                only_house: this.only_house[this.only_house_index]
            }
            const rules = {
                area: {
                    required: true,
                    text: '房屋面积'
                },
                all_price: {
                    required: true,
                    text: '房屋总价'
                },
            }
            if (checkSubmit(params, rules)) {
                this.$router.push({
                    name: 'taxes_result',
                    params: {
                        params: JSON.stringify(calcOldHouse(params))
                    }
                })
            }
        }
    }
}
